import React from 'react';
import { Link } from 'react-router-dom';

import Icone from 'Component/Icone';

interface Props {
  bloco?: boolean;
  icone?: string;
  children?: string | React.ReactElement | React.ReactElement[];
  className?: string;
  target?: '_blank' | '_self';
  tema?:
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'light'
    | 'dark'
    | 'darkless'
    | 'primary'
    | 'secondary'
    | 'transparent'
    | 'outline-success'
    | 'outline-warning'
    | 'outline-danger'
    | 'outline-info'
    | 'outline-light'
    | 'outline-dark'
    | 'outline-darkless'
    | 'outline-primary'
    | 'outline-secondary';
  to: string;
  circulo?: boolean;
  lg?: boolean;
  ms?: boolean;
  me?: boolean;
  texto?: string;
}

const BotaoLink = (props: Props): React.ReactElement => {
  const {
    icone,
    children,
    className = '',
    tema = 'primary',
    to,
    target = '_self',
    bloco = false,
    circulo,
    lg,
    ms,
    me,
    texto,
  } = props;

  if (to.indexOf('://') != -1) {
    return (
      <a
        href={to}
        className={[
          'text-nowrap',
          `btn btn-${tema}`,
          lg && 'btn-lg',
          ms && 'ms-2',
          me && 'me-2',
          circulo && 'rounded-circle',
          bloco && 'd-block',
          className,
        ].className()}
        target={target}
      >
        {icone && (
          <Icone nome={icone} {...(children || texto ? { className: 'me-2' } : {})} />
        )}
        {children ? children : texto}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={[
        'text-nowrap',
        `btn btn-${tema}`,
        lg && 'btn-lg',
        ms && 'ms-2',
        me && 'me-2',
        circulo && 'rounded-circle',
        bloco && 'd-block',
        className,
      ].className()}
      target={target}
    >
      {icone && (
        <Icone nome={icone} {...(children || texto ? { className: 'me-2' } : {})} />
      )}
      {children ? children : texto}
    </Link>
  );
};

export default BotaoLink;
